import { useState, useEffect } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";

const CheckoutForm = ({ onConfirm }) => {
  const [name, setName] = useState("");
  const [dni, setDni] = useState("");
  const [cuit, setCuit] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});

  // 🔹 Cargar automáticamente el email del usuario logueado
  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) setEmail(user.email);
    });
    return () => unsubscribe();
  }, []);

  const validateForm = () => {
    const errors = {};

    if (!name.trim()) errors.name = "El nombre es requerido";
    if (!dni.trim()) errors.dni = "El DNI es requerido";
    if (!cuit.trim()) errors.cuit = "El CUIT/CUIL es requerido";
    if (!phone.trim()) errors.phone = "El teléfono es requerido";
    if (!email.trim() || !email.includes("@"))
      errors.email = "El email no es válido";

    return errors;
  };

  const handleConfirm = (event) => {
    event.preventDefault();
    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length === 0) {
      onConfirm({ name, phone, email });
    } else {
      setErrors(validationErrors);
    }
  };

  const handleCancel = (event) => {
    event.preventDefault();
    setName("");
    setDni("");
    setCuit("");
    setPhone("");
    setErrors({});
  };

  return (
    <form
      onSubmit={handleConfirm}
      className="max-w-3xl mx-auto p-4 sm:p-6 bg-white rounded-lg shadow-md"
    >
      <h2 className="text-xl font-semibold mb-6 text-center text-gray-800">
        Datos del comprador
      </h2>

      {/* GRID RESPONSIVE */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {/* Nombre */}
        <div>
          <label className="block mb-2 text-sm font-medium text-gray-900">
            Nombre
          </label>
          <input
            type="text"
            value={name}
            onChange={({ target }) => setName(target.value)}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full p-2.5"
          />
          {errors.name && (
            <p className="text-red-500 text-sm mt-1">{errors.name}</p>
          )}
        </div>

        {/* DNI */}
        <div>
          <label className="block mb-2 text-sm font-medium text-gray-900">
            DNI
          </label>
          <input
            type="text"
            value={dni}
            onChange={({ target }) => setDni(target.value)}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full p-2.5"
          />
          {errors.dni && (
            <p className="text-red-500 text-sm mt-1">{errors.dni}</p>
          )}
        </div>

        {/* CUIT/CUIL */}
        <div>
          <label className="block mb-2 text-sm font-medium text-gray-900">
            CUIT / CUIL
          </label>
          <input
            type="text"
            value={cuit}
            onChange={({ target }) => setCuit(target.value)}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full p-2.5"
          />
          {errors.cuit && (
            <p className="text-red-500 text-sm mt-1">{errors.cuit}</p>
          )}
        </div>

        {/* Teléfono */}
        <div>
          <label className="block mb-2 text-sm font-medium text-gray-900">
            Teléfono
          </label>
          <input
            type="tel"
            value={phone}
            onChange={({ target }) => setPhone(target.value)}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full p-2.5"
          />
          {errors.phone && (
            <p className="text-red-500 text-sm mt-1">{errors.phone}</p>
          )}
        </div>

        {/* Email */}
        <div className="sm:col-span-2">
          <label className="block mb-2 text-sm font-medium text-gray-900">
            Email
          </label>
          <input
            type="email"
            value={email}
            readOnly
            className="bg-gray-100 border border-gray-300 text-gray-500 text-sm rounded-lg w-full p-2.5 cursor-not-allowed"
          />
          {errors.email && (
            <p className="text-red-500 text-sm mt-1">{errors.email}</p>
          )}
        </div>
      </div>

      {/* BOTONES */}
      <div className="flex flex-col sm:flex-row justify-center gap-3 mt-8">
        <button
          type="submit"
          className="rounded-full border border-gray-300 py-2 px-6 font-medium hover:bg-black hover:text-white transition"
        >
          Enviar
        </button>
        <button
          type="button"
          onClick={handleCancel}
          className="rounded-full border border-gray-300 py-2 px-6 font-medium hover:bg-black hover:text-white transition"
        >
          Cancelar
        </button>
      </div>
    </form>
  );
};

export default CheckoutForm;
